import { render, staticRenderFns } from "./ArticleDeleteWarningDialog.vue?vue&type=template&id=54fb9ccb"
import script from "./ArticleDeleteWarningDialog.vue?vue&type=script&lang=ts"
export * from "./ArticleDeleteWarningDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports